import React from "react"
import { createPortal } from "react-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ICONS = {
  success: ["circle-check", "text-emerald-400"],
  error:   ["triangle-exclamation", "text-rose-400"],
  info:    ["circle-info", "text-sky-300"],
  tip:     ["lightbulb", "text-amber-300"],
}

const Toasts = ({ toasts, onDismiss }) => createPortal(
  <div className="fixed bottom-5 right-5 z-[1300] flex flex-col items-end gap-2 pointer-events-none">
    {toasts.map(toast => {
      const [icon, tone] = ICONS[toast.tone] || ICONS.info
      return (
        <button
          key={toast.id}
          type="button"
          onClick={() => onDismiss(toast.id)}
          className="pp-toast pointer-events-auto flex items-center gap-2.5 max-w-sm px-3.5 py-2.5 rounded-lg bg-slate-900 text-white text-[13px] text-left"
        >
          <FontAwesomeIcon icon={icon} className={tone} />
          <span>{toast.message}</span>
        </button>
      )
    })}
  </div>,
  document.body,
)

export default Toasts
